// Import stores
import AppStore from './AppStore';
import AssessmentStore from './AssessmentStore';
import ReportStore from './ReportStore';
import UserStore from './UserStore';
import ActivityStore from './ActivityStore';
import SurveyStore from './SurveyStore';
import BrandStore from './BrandStore';

// Combine stores
const store = {
  AppStore,
  AssessmentStore,
  ReportStore,
  UserStore,
  ActivityStore,
  SurveyStore,
  BrandStore
};

export default store;
